import React from "react";

function AddCustomerTabs({
  title1,
  title2,
  onClick1,
  onClick2,
  currentStep = 0,
  style,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        ...style,
      }}
    >
      <div
        style={{
          borderBottom:
            currentStep === 0 ? "4px solid dodgerblue" : "4px solid #F3F3F3",
          width: "50%",
          cursor: "pointer",
        }}
        onClick={onClick1}
      >
        <p
          style={{
            padding: 0,
            margin: 0,
            fontSize: 13,
            fontFamily: "Roboto",
            fontWeight: "500",
            textAlign: "center",
            color: currentStep === 0 ? "dodgerblue" : "black",
            marginBottom: 0,
          }}
        >
          {title1}
        </p>
      </div>
      <div
        style={{
          borderBottom:
            currentStep === 1 ? "4px solid dodgerblue" : "4px solid #F3F3F3",
          width: "50%",
          display: "flex",
          justifyContent: "center",
        }}
        onClick={onClick2}
      >
        <p
          style={{
            padding: 0,
            margin: 0,
            fontSize: 13,
            fontFamily: "Roboto",
            fontWeight: "500",
            textAlign: "end",
            cursor: "pointer",
            color: currentStep === 1 ? "dodgerblue" : "black",
            marginBottom: 0,
          }}
        >
          {title2}
        </p>
      </div>
    </div>
  );
}

export default AddCustomerTabs;
